import { makeStyles } from "@material-ui/core/styles";
import {
  fade,
  lighten,
  darken,
} from "@material-ui/core/styles/colorManipulator";
import decoWave from "~/static/images/mobile/deco-wave-footer.png";

const footerStyles = makeStyles((theme) => ({
  link: {
    margin: theme.spacing(1, 1.5),
  },
  invert: {},
  decoTop: {
    fill:
      theme.palette.type === "dark"
        ? darken(theme.palette.primary.light, 0.65)
        : lighten(theme.palette.primary.light, 0.8),
    height: 300,
    width: "100%",
    position: "absolute",
    top: -10,
    [theme.breakpoints.up("xl")]: {
      display: "none",
    },
    [theme.breakpoints.up("lg")]: {
      transform: "scale(1.5, 1)",
    },
    [theme.breakpoints.down("md")]: {
      transform: "scale(1.2, 0.7)",
      top: -80,
    },
    [theme.breakpoints.down("xs")]: {
      transform: "scale(0.5, 0.5)",
      top: -90,
      left: -330,
      width: 1280,
    },
  },
  footerHomePadding: {
    [theme.breakpoints.up("md")]: {
      paddingBottom: "100px !important",
    },
  },
  footer: {
    position: "relative",
    paddingBottom: theme.spacing(12),
    backgroundImage: "linear-gradient(to right, #2e74c5, #673ab7)",
    maxWidth: "unset",
    [theme.breakpoints.up("md")]: {
      paddingBottom: "34px",
      paddingTop: "34px",
    },
    zIndex: 499,
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "49px",
    },
    "& $accordionRoot": {
      margin: "0 auto",
      marginTop: theme.spacing(2),
    },
    "& p": {
      color: theme.palette.common.white,
      [theme.breakpoints.down("sm")]: {
        marginBottom: theme.spacing(4),
      },
    },
    "& ul": {
      margin: 0,
      padding: 0,
    },
    "& li": {
      listStyle: "none",
      marginBottom: "2px",
      "& a": {
        fontSize: 14,
        textDecoration: "none !important",
        color: "#fff",
        fontWeight: 600,
        "&:hover": {
          color: "#fff",
        },
      },
    },
    "&$invert": {
      "& p": {
        color: theme.palette.text.primary,
      },
      "& li a": {
        color: "#fff",
      },
      "& $logo": {
        "& h6": {
          color: theme.palette.primary.dark,
        },
      },
      "& $selectLang": {
        color: "#fff",
        "& svg": {
          color: "#fff",
        },
      },
    },
  },
  ctnLinkWhiteContent: {

    "& p": {
      color: theme.palette.text.primary,
    },
    "& li a": {
      color: "#000 !important",
    },
    "& $logo": {
      "& h6": {
        color: theme.palette.primary.dark,
      },
    },
    "& $selectLang": {
      color: "#000 !important",
      "& svg": {
        color: "#000 !important",
      },
    },
  },
  title: {
    color: "#fff",
    fontSize: 18,
    // textTransform: 'uppercase',
    marginBottom: "12px",
    fontWeight: 800,
  },
  nullMarginBototm: {
    marginTop: "8px",
    marginBottom: 0,
  },
  titleCostum: {
    marginBottom: "11px",
    marginLeft: "2px",
  },
  descriptionTitle: {
    marginTop: "2px",
    color: "#fff",
    fontSize: 14,
    marginBottom: "12px",
  },
  logo: {
    textAlign: "center",
    marginBottom: theme.spacing(3),
    "& img": {
      width: 64,
      marginRight: theme.spacing(),
    },
    "& h6": {
      color: theme.palette.common.white,
    },
  },
  footerDesc: {
    display: "block",
    fontSize: 14,
  },
  socmed: {
    display: "flex",
    justifyContent: "center",
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(0),
    },
    "& a": {
      margin: theme.spacing(),
      color: theme.palette.primary.dark,
      border: `1px solid ${theme.palette.primary.mfs}`,
      width: 48,
      height: 48,
      "& i": {
        color: theme.palette.common.white,
        fontSize: "24px",
      },
      "& svg": {
        color: theme.palette.primary.mfs,
        fontSize: "24px",
      },
      "&:hover": {
        backgroundColor: theme.palette.primary.mfs,
        "& svg": {
          color: theme.palette.primary.white,
        },
      },
    },
    "& i": {
      fontSize: 24,
    },
  },
  icon: {
    "& > img": {
      width: 20,
      height: 30,
      objectFit: "contain",
    },
  },
  iconlangStyle: {
    color: "#939598 !important",
  },
  selectLang: {
    margin: "0 auto",
    width: 200,
    display: "inherit",
    marginTop: theme.spacing(2),
    color: "#fff",
    "& $icon": {
      top: 21,
      color: "#fff",
      position: "relative",
      "& + div": {
        background: "none !important",
        padding: theme.spacing(1.5, 1.5, 1.5, 4),
        width: "calc(100% - 32px)",
      },
    },
    "& svg": {
      color: "#939598 !important",
    },
    "& fieldset": {
      boxShadow: "0 1.5px 12px 2px rgba(0, 0, 0, 0.06)",
      border: `1px solid ${fade(theme.palette.primary.body, 0.5)} !important`,
      "& legend": {
        top: 5,
        position: "relative",
        borderTop: `1px solid ${fade(theme.palette.primary.body, 0.5)}`,
      },
    },
    [theme.breakpoints.down("sm")]: {
      width: "70%",
      height: "44px",
    },
  },
  ctnSelectWhite: {
    color: "#000 !important",
    "& $icon": {
      color: "#000 !important",
    },
    "& svg": {
      color: "#939598 !important",
    },
  },
  siteMapItem: {
    [theme.breakpoints.down("md")]: {
      paddingBottom: "0 !important",
      paddingTop: "0 !important",
    },
  },
  accordionRoot: {
    background: "none",
    boxShadow: "none",
    color: "#fff",
    maxWidth: 480,
    "&$invert": {
      color: theme.palette.text.black,
      "& svg": {
        fill: theme.palette.text.black,
      },
    },
    "& svg": {
      fill: theme.palette.common.black,
    },
  },
  accordionContent: {
    margin: 0,
  },
  accordionIcon: {
    padding: 0,
  },
  footerDeco: {
    position: "relative",
    top: 0,
    backgroundImage: `linear-gradient(30deg, ${theme.palette.secondary.black} 140%)`,
    [theme.breakpoints.up("md")]: {
      marginTop: -118,
      zIndex: 111,
      backgroundColor: "#fff",
      paddingTop: 68,
    },
    [theme.breakpoints.up("xl")]: {
      // paddingTop: theme.spacing(10),
      // marginTop: theme.spacing(10),
      // marginTop: -479,
      marginTop: -130,
    },
    [theme.breakpoints.down("md")]: {
      zIndex: 111,
      backgroundColor: "#fff",
      paddingTop: 50,
      marginTop: -158,
    },
    "&:before": {
      zIndex: 1,
      content: "\"\"",
      width: "100%",
      height: 500,
      position: "absolute",
      top: theme.spacing(10),
      left: 0,
      opacity: 0.1,
      background: `url(${decoWave}) no-repeat transparent`,
      backgroundSize: "100%",
    },
  },
  decoration: {
    position: "absolute",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    overflow: "hidden",
    clip: "rect(0, auto, auto, 0)",
    "& svg": {
      fill: theme.palette.secondary.main,
      opacity: 0.15,
      position: "fixed",
      top: 0,
    },
  },
  leftDeco: {
    left: 0,
    width: 1200,
    height: 1500,
    transform: "scale(0.5)",
    transformOrigin: "top left",
  },
  rightDeco: {
    right: -450,
    width: 1200,
    height: 1500,
    transform: "scale(0.5)",
    transformOrigin: "top right",
  },
  action: {
    textAlign: "center",
    position: "relative",
    zIndex: 499,
    [theme.breakpoints.down("md")]: {
      paddingTop: 0,
      paddingBottom: theme.spacing(3),
    },
    [theme.breakpoints.down("xs")]: {
      paddingBottom: 0,
    },
  },
  btnDownload: {},
  btnAreaDownload: {
    marginBottom: "26px !important",
    [theme.breakpoints.down("xs")]: {
      marginTop: "16px",
      marginBottom: "12px !important",
      justifyContent: "space-around",
    },
    "& div": {
      [theme.breakpoints.down("xs")]: {
        margin: 0,
      },
    },
  },
  btnArea: {
    margin: theme.spacing(2, 0),
    marginBottom: "48px",
    justifyContent: "center",
    position: "relative",
    display: "flex",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "center",
      paddingLeft: "20px",
      paddingRight: "20px",
      marginBottom: "38px",
      marginTop: "12px",
    },
    "& div": {
      // [theme.breakpoints.up('sm')]: {
      //   marginRight: theme.spacing(2),
      // },
      [theme.breakpoints.down("xs")]: {
        margin: 4,
      },
      "& $btnDownload": {
        width: "248px",
        height: "52px !important",
        "& > .MuiButton-label": {
          fontWeight: "800",
          textTransform: "none",
          fontSize: "16px",
        },
        [theme.breakpoints.down("xs")]: {
          width: "96%",
          "& > .MuiButton-label": {
            fontWeight: "bold",
            fontSize: "14px",
            paddingLeft: "14px",
            paddingRight: "14px",
            lineHeight: "18px",
          },
        },
      },
    },
    "& a": {
      [theme.breakpoints.up("sm")]: {
        marginRight: theme.spacing(2),
      },
      [theme.breakpoints.down("xs")]: {
        margin: 4,
        width: 133,
      },
      "& img": {
        width: 200,
        [theme.breakpoints.down("xs")]: {
          width: "100%",
        },
      },
    },
    // "& a:first-child": {
    //   marginRight: 12,
    // },
  },
  subtitle: {
    color: theme.palette.primary.black,
    fontSize: "25px",
    fontWeight: 600,
    lineHeight: "47px",
    margin: "0 auto",
    maxWidth: "75%",
    [theme.breakpoints.down("sm")]: {
      marginTop: "20px",
      lineHeight: "36px",
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "10px",
    },
  },
  spacingStyle: {
    [theme.breakpoints.up("md")]: {
      position: "relative",
      left: "17%",
    },
  },
  footerMobileOuter: {
    [theme.breakpoints.down("sm")]: {
      marginTop: "24px",
      // borderTop: `1px solid ${theme.palette.primary.body}`,
      // paddingTop: '20px !important',
      textAlign: "center",
      "& li": {
        "& a": {
          fontSize: "18px",
          fontWeight: 600,
        },
      },
    },
  },
  containerSubscribe: {
    [theme.breakpoints.down("md")]: {
      marginBottom: theme.spacing(2),
    },
    [theme.breakpoints.down("sm")]: {
      display: "block",
      margin: "auto",
      flexDirection: "column",
      width: "100%",
      paddingLeft: "0px",
    },
    paddingLeft: "32px",
    paddingBottom: theme.spacing(2),
  },
  emailContainer: {
    position: "relative",
    marginRight: "20px",
    width: "70%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginRight: "0px",
      padding: theme.spacing(0, 10),
      [theme.breakpoints.down("xs")]: {
        paddingLeft: "10px",
        paddingRight: "10px",
      },
    },
    "& .MuiFormControl-root": {
      display: "flex",
    },
    "& .MuiFilledInput-root": {
      background: "transparent",
      border: "1px solid #ddd",
      backgroundColor: "#fff",
    },
    "& .MuiInputLabel-shrink": {
      color: theme.palette.primary.mfs,
    },
    "& .Mui-focused": {
      border: `1px solid ${theme.palette.primary.mfs}`,
    },
    "& .MuiFilledInput-input": {
      borderRadius: "12px",
    }
  },
  btnStyle: {
    width: "24% !important",
    height: "40px !important",
    [theme.breakpoints.down("sm")]: {
      display: "flex !important",
      margin: "auto !important",
      width: "160px !important",
      marginTop: "18px !important",
      marginBottom: "30px !important",
    },
    "& > span": {
      color: "#000 !important"
    }
  },
  circularStyle: {
    color: theme.palette.primary.mfs,
    width: "30px",
    height: "30px",
    marginRight: "20px",
    [theme.breakpoints.down("sm")]: {
      margin: "auto",
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
  },
  textSuccess: {
    color: "#13ad02",
    fontSize: "12px",
    paddingLeft: "2px",
    paddingTop: "4px",
  },
  errorText: {
    color: "red",
  },
  blackText: {
    color: "#000"
  }
}));

export default footerStyles;
